const checkIsTimezoneOffsetNeeded = (): boolean =>
  // NOTE: native is true
  false;

export { checkIsTimezoneOffsetNeeded };
